<template>
    <div>
        <!-- Header section -->
        <header class="header-section-team header-section">
            <div class="container text-right">
                <div class="page-info">
                    <h2>Галерия</h2>
                    <div class="page-links">
                        <router-link to="/">Начало</router-link>
                        <span class="active">Галерия</span>
                    </div>
                </div>
            </div>
        </header>
        <!-- Header section end -->
        <div class="container-fluid">
            <LightGallery
                    :images="gallery"
                    :index="index"
                    :disable-scroll="true"
                    @close="index = null"
            />
            <div class="row album">
                <div class="col-md-4 p-1" v-for='(thumb, thumbIndex) in gallery' :key="thumbIndex"
                     @click="index = thumbIndex; selectItem(thumb.id)">
                    <img style="width: 100%; height: 100%; object-fit: cover;" :src="thumb.url" class=" embed-responsive-item" :alt="thumb.id">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { db } from '../../firebase';
    import { LightGallery } from 'vue-light-gallery';

    export default {
        components: {
            LightGallery,
        },
        data() {
            return {
                gallery: [],
                index: null,
            }
        },
        created() {
            db.collection('gallery').orderBy('createdAt', 'desc').onSnapshot((snapshotChange) => {
                this.gallery = [];
                snapshotChange.forEach((doc) => {
                    this.gallery.push({
                        id: doc.id,
                        url: doc.data().image,
                    });
                });
            })
        },
      methods: {
        selectItem(item) {
          return console.log(item);
        }
      },
    }
</script>
<style>
    .link{
        text-decoration: none !important;
    }
</style>
